// Auto generated file, do not manually modify!
// com.hotpads.rentalmanagerapi.api.web.v1.users.properties.deactivate.RentalManagerUserPropertyDeactivateWebApiHandler

import { getClient } from '../../client';
import { httpFrontEndRequest } from '@zg-rentals/ts-client-http-client';

import type {
  DeactivateListingRequestDto,
  DeactivateListingResponseDto,
  GetDeactivateListingTenantsSummaryResponseDto,
  ListingAlias,
} from '../..';

interface LeasesParams {
  listingAlias: ListingAlias;
  type: string;
  value: boolean;
}
interface TenantsSummaryParams {
  listingAlias: ListingAlias;
}

export const RentalManagerUserPropertyDeactivateWebApiHandler_deactivateListing_Path =
  '/api/web/v1/users/properties/deactivate/deactivateListing';

export const RentalManagerUserPropertyDeactivateWebApiHandler_deactivateListing = (
  postData: DeactivateListingRequestDto,
  client = getClient(),
) => {
  return httpFrontEndRequest<never, DeactivateListingRequestDto, DeactivateListingResponseDto>(
    {
      endpoint: RentalManagerUserPropertyDeactivateWebApiHandler_deactivateListing_Path,
      method: 'POST',
      contextPath: '/rental-manager-api',
      postData: postData,
    },
    client,
  );
};

export const RentalManagerUserPropertyDeactivateWebApiHandler_leases_Path =
  '/api/web/v1/users/properties/deactivate/leases';

/**
 * Save leases survey response. Types: haveSignedLease, uploadSignedLease, haveLeaseAgreement, uploadUnsignedLease, createLease
 * @deprecated
 */
export const RentalManagerUserPropertyDeactivateWebApiHandler_leases = (
  getParams: LeasesParams,
  client = getClient(),
) => {
  return httpFrontEndRequest<LeasesParams, never, void>(
    {
      getParams: getParams,
      endpoint: RentalManagerUserPropertyDeactivateWebApiHandler_leases_Path,
      method: 'POST',
      contextPath: '/rental-manager-api',
    },
    client,
  );
};

export const RentalManagerUserPropertyDeactivateWebApiHandler_tenantsSummary_Path =
  '/api/web/v1/users/properties/deactivate/tenantsSummary';

/**
 * Get tenants leases and payments summary when listing is deactivated
 */
export const RentalManagerUserPropertyDeactivateWebApiHandler_tenantsSummary = (
  getParams: TenantsSummaryParams,
  client = getClient(),
) => {
  return httpFrontEndRequest<TenantsSummaryParams, never, GetDeactivateListingTenantsSummaryResponseDto>(
    {
      getParams: getParams,
      endpoint: RentalManagerUserPropertyDeactivateWebApiHandler_tenantsSummary_Path,
      method: 'GET',
      contextPath: '/rental-manager-api',
    },
    client,
  );
};
